var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-col',[_c('h2',[_vm._v("Modelo de contrato Empresa")]),_c('iframe',{attrs:{"width":"100%","height":"350px","src":_vm.uri}})]),_c('el-col',[_c('h2',[_vm._v("Modelo de contrato persona fisica")]),_c('iframe',{attrs:{"width":"100%","height":"350px","src":_vm.uri2}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }